import React from "react";
import { Box, Grid, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Loader from "components/loader/Loader";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import FaqQuestion from "./FaqQuestion";


function FaqTab(props) {
  const searchParams = new URLSearchParams(window.location.search);
  const isMobile = searchParams.get("isMobile");
  const { faqLoader, faqSectionLoader } = props;

  return (
    <Grid container>
      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle marginBlock10">
          <TabContext value={props.value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <TabList
                  className="minHeight32"
                  onChange={props.handleChange}
                  aria-label="lab API tabs example"
                  xs={6}
                  TabIndicatorProps={{
                    style: { display: "none" },
                  }}
                >
                  <Tab
                    label="Customer"
                    value="Customer"
                    className="tabStyleOne"
                  />
                  <Tab label="Driver" value="Driver" className="tabStyleOne" />
                </TabList>
              </Grid>
            </Grid>
            <TabPanel value="Customer" className="tabPanelStyle">
              {(faqSectionLoader || faqLoader) ? (
                <Loader />
              ) : props?.faqData?.length > 0  ? (
                <FaqQuestion
                  faqData={props?.faqData}
                  isMobile={isMobile}
                />
              ) : (
                <CommonNoDataFound />
              )}
            </TabPanel>
            <TabPanel value="Driver" className="tabPanelStyle">
              {(faqSectionLoader || faqLoader) ? (
                <Loader />
              ) : props?.faqData?.length > 0 ? (
                <FaqQuestion faqData={props?.faqData} />
              ) : (<CommonNoDataFound /> )
              }
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default FaqTab;